import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./switcher.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { Variant as ButtonVariant } from 'wds/button';
import { buildNavigationUrl } from '~/modules/helpers/searchUrlHelper';
import { i18nStore, selectSearchLabels, WireI18n } from '~/modules/stores/i18nStore';
import { getSearchKey, searchStore, selectSearchResults } from '~/modules/stores/searchStore';
class SearchSwitcher extends LightningElement {
  constructor(...args) {
    super(...args);
    this.totals = undefined;
    this.labels = void 0;
    this.searchParams = {
      keyword: ''
    };
    this.currentKeyTotalResults = undefined;
  }
  setSearchTotalsFromState(state) {
    this.searchParams = state.searchParams;
    const response = selectSearchResults(state, getSearchKey(state.searchParams));
    this.currentKeyTotalResults = response?.totalSearchResults;
    if (state.searchParams?.keyword) {
      const keywordTotals = state.totals?.get(state.searchParams.keyword);
      this.totals = keywordTotals;
    } else if (this.totals) {
      this.totals = undefined;
    }
  }
  searchType(buttonName) {
    return buttonName === 'apps & solutions' ? 'apps' : 'consultants';
  }
  switchToApps() {
    if (this.searchParams.type !== 'apps') {
      this.handleSwitch(undefined);
    }
  }
  switchToConsultants() {
    if (this.searchParams.type !== 'consultants') {
      this.handleSwitch('consultants');
    }
  }
  handleSwitch(type) {
    // flipping the selected type
    const switcherEvent = new CustomEvent('searchtypechange', {
      detail: {
        type
      }
    });
    this.dispatchEvent(switcherEvent);
  }
  tabVariant(tab) {
    return (this.searchParams?.type || 'apps') === tab ? ButtonVariant.Primary : ButtonVariant.Secondary;
  }
  get tabsVariants() {
    const isAppsSelected = this.tabVariant('apps') === ButtonVariant.Primary;
    return {
      apps: this.tabVariant('apps'),
      appsSelected: isAppsSelected,
      consultants: this.tabVariant('consultants'),
      consultantsSelected: !isAppsSelected
    };
  }
  get appSolutionsTabLabel() {
    const {
      i18n
    } = i18nStore.getState();
    if (this.totals) {
      return i18n.search.tabs.withTotals.appsAndSolutions({
        total: this.totals.apps || '0'
      });
    }
    return i18n.search.tabs.withoutTotals.appsAndSolutions();
  }
  get consultantsTabLabel() {
    const {
      i18n
    } = i18nStore.getState();
    if (this.totals) {
      return i18n.search.tabs.withTotals.consultants({
        total: this.totals.consultants || '0'
      });
    }
    return i18n.search.tabs.withoutTotals.consultants();
  }
  handleAnalytics(event) {
    const searchType = this.searchType(event.detail.button?.callToAction.name);
    event.detail.keyword = this.searchParams.keyword;
    event.detail.searchType = searchType || 'apps';
    if (this.totals) {
      event.detail.searchTotal = searchType === 'apps' ? this.totals.apps : this.totals.consultants;
    } else if (this.currentKeyTotalResults) {
      event.detail.searchTotal = this.currentKeyTotalResults;
    }
    if (event.detail.button?.callToAction) {
      event.detail.button.callToAction.label = searchType === 'apps' ? this.appSolutionsTabLabel : this.consultantsTabLabel;
    }
    event.detail.navigateTo = buildNavigationUrl(this.searchParams, {
      type: searchType,
      resetState: true
    });
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SearchSwitcher, {
  track: {
    totals: 1
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectSearchLabels
        };
      }
    },
    setSearchTotalsFromState: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: searchStore
        };
      }
    }
  },
  fields: ["searchParams", "currentKeyTotalResults"]
});
const __lwc_component_class_internal = _registerComponent(SearchSwitcher, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;